
:host {
	--guide-opacity: 0.5;
}

:host .smoothly-date-text-part:focus {
	outline: none;
}

:host .guide {
	opacity: var(--guide-opacity);
}

:host .smoothly-date-text-part:not(.is-complete) + .guide + .smoothly-date-separator {
	opacity: var(--guide-opacity);
}
